<template>
  <div v-if="$auth.ready()" id="app" :class="[minWidthClass, 'bg-light', 'd-flex', 'flex-column']" >
    <!-- Header -->
      <b-navbar toggleable="md" type="dark" variant="dark" class="w-100"  v-if="$route.name!='MPTM'">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand href="/" >
          <img src="./assets/logo.png" class="d-inline-block align-top logo">
          凝聚态物质科学数据中心
        </b-navbar-brand>
        <b-collapse is-nav id="nav_collapse" >
          <b-navbar-nav>
            <b-nav-item to="/">主页</b-nav-item>
            <b-nav-item href="http://159.226.208.71:8080/#/services/materials" target="_blank">数据搜索</b-nav-item>
            <!-- <b-nav-item v-if="true" to="/calculate">Calculate</b-nav-item> -->
            <!-- <b-nav-item to="/upload">数据汇交</b-nav-item>
            <b-nav-item to="/apps">应用工具</b-nav-item> -->
            <b-nav-item to="/literature_trends/newest">文献动态</b-nav-item>
            <b-nav-item href="http://condmatt.iphy.ac.cn/materialchat/home/chat" target="_blank">数据问答</b-nav-item>
            <b-nav-item href="http://condmatt.iphy.ac.cn/hub" target="_blank">AI在线环境</b-nav-item>
            <b-nav-item to="/help">数据政策</b-nav-item>
            <b-nav-item to="/about">关于我们</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav v-if="true" class="ml-auto">
            <!-- <b-nav-item v-show="!$auth.check()" to="/login">登录</b-nav-item right> -->
            <b-nav-item-dropdown v-show="$auth.check()" right>
              <!-- Using button-content slot -->
              <template slot="button-content">
                <em>用户</em>
              </template>
              <!--
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              -->
              <b-dropdown-item to="/profile">个人主页</b-dropdown-item>
              <b-dropdown-item to="/myproj">我的项目</b-dropdown-item>
              <b-dropdown-item href="#" @click="logout">登出</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>

        </b-collapse>
      </b-navbar>

      <!-- Main panel -->
      <b-container fluid class="">
        <!-- <keep-alive :include="['Browse']"> -->
        <!-- <keep-alive :include="['Search', 'Browse']"> -->
        <!--  <router-view :key="$route.name + (['materials', 'browse'].includes($route.name) ? ($route.params.id || '') : '')"></router-view> -->
          <router-view></router-view>
         
         
        <!-- </keep-alive> -->
      </b-container>

      <!-- Footer -->
        <b-container fluid class="page-footer text-white px-5 pt-3"> 
          <b-row>
            <b-col>
              <h5>组织机构</h5>
              <p class="text-light">
              中国科学院物理研究所-凝聚态物质科学数据中心
              </p>
            </b-col>
            <b-col>
              <h5>联系我们</h5>
              <p class="text-light">中国 北京市 海淀区 中关村南三街8号 100190</p>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid class="pb-3 bg-dark text-light text-right px-5">
          © 2023 Copyright: 
          <a target="_blank" class="text-success" href="http://www.iop.cas.cn/">中国科学院物理研究所</a>
        </b-container>
  </div>
</template>

<script>

export default {
  name: 'app',
  metaInfo: {
    title: 'Data Center for Condensed Matter Physics, Chinese Academy of Sciences'
  },

  data () {
    return {
      activeIndex: '1'
    }
  },

  computed: {
    minWidthClass () {
      if (this.$route.name === 'home') {
        return 'min-width-1200'
      }
      if (this.$route.name === 'materials') {
        return 'min-width-1200'
      }
      return 'min-width-1200'
    }
  },

  methods: {
    logout () {
      this.$auth.logout({
        makeRequest: true,
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
